import { render, staticRenderFns } from "./DecompositionCards.vue?vue&type=template&id=6d67801a"
import script from "./DecompositionCards.vue?vue&type=script&lang=js"
export * from "./DecompositionCards.vue?vue&type=script&lang=js"
import style0 from "./DecompositionCards.vue?vue&type=style&index=0&id=6d67801a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports